import { render, staticRenderFns } from "./ComplaintsDetail.vue?vue&type=template&id=d40d6efc"
import script from "./ComplaintsDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports